export default __webpack_public_path__ + "static/media/Icon-Add.5b84cc57.svg";